import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ChatMessageText = styled(Box)({
  wordBreak: 'break-word',
  whiteSpace: 'pre-wrap',
});
